var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66659 6.66675H33.3333C35.1666 6.66675 36.6666 8.2605 36.6666 10.2084V31.4584C36.6666 33.4063 35.1666 35.0001 33.3333 35.0001H6.66659C4.83325 35.0001 3.33325 33.4063 3.33325 31.4584V10.2084C3.33325 8.2605 4.83325 6.66675 6.66659 6.66675ZM21.7666 21.4355L32.6666 14.1928C33.0833 13.9095 33.3333 13.4313 33.3333 12.9178C33.3333 11.7313 32.1166 11.023 31.1666 11.6428L19.9999 19.0626L8.83325 11.6428C7.88325 11.023 6.66659 11.7313 6.66659 12.9178C6.66659 13.4313 6.91659 13.9095 7.33325 14.1928L18.2333 21.4355C19.3166 22.1616 20.6833 22.1616 21.7666 21.4355Z",
    fill: "#B0B3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d4f3629a.svg";
export { ForwardRef as ReactComponent };